<template>

  <el-dialog width="300px" append-to-body title="查看核销码" center="" :visible.sync="visible" :before-close="handleClose">
    <div class="flex-row flex-xy-center">
      <span class="fs30 fwb">{{ oldOrder.fetch_code }}</span>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="primary" v-clipboard:copy="oldOrder.fetch_code"
        v-clipboard:success="clipboardSuccess">复制</el-button>
    </div>

  </el-dialog>
</template>

<script>
import clipboard from '@/directive/clipboard' // 复制指令
export default {
  name: 'OrderFetch',
  components: {
  },
  directives: {
    clipboard
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    oldOrder: {
      type: Object,
      default: {},
    }
  },
  watch: {
    visible(value) {
      if (value) {

      }
    }
  },
  data() {
    return {

    };
  },
  methods: {
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      this.handleClose()
    },
    // 关闭窗口
    handleClose() {
      // 更新visible参数
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>